<article class="ni-item" [class.read]="item.read">
  <div class="ni-item-head" (click)="toggleExpand()">
    <img class="ni-thumb" *ngIf="item.thumbnail" [src]="item.thumbnail" alt=""
         loading="lazy" referrerpolicy="no-referrer">
    <div class="ni-item-main">
      <div class="ni-item-meta">
        <span class="ni-type ni-type-{{ item.sourceType }}">{{ item.sourceType }}</span>
        <span class="ni-source">{{ item.source }}</span>
        <span class="ni-date" *ngIf="item.publishedAt">
          &middot; {{ item.publishedAt | date:'mediumDate' }}
        </span>
      </div>
      <h3 class="ni-title">{{ item.title }}</h3>
      <p class="ni-snippet" *ngIf="!expanded && item.summary">{{ item.summary }}</p>
    </div>
    <button class="ni-like" [class.on]="item.liked" title="Like"
            (click)="$event.stopPropagation(); toggleLike.emit()">&hearts;</button>
  </div>

  <div class="ni-item-body" *ngIf="expanded">
    <iframe class="ni-embed" *ngIf="youtubeEmbed" [src]="youtubeEmbed | safeUrl"
            frameborder="0" allowfullscreen></iframe>
    <p class="ni-summary" *ngIf="item.summary">{{ item.summary }}</p>
    <a class="ni-open" [href]="item.link" target="_blank" rel="noopener">Open original &#8599;</a>
  </div>
</article>
